import { FC, memo } from 'react';

import { ITicket, TicketStatusInfo, CounterStatus, TicketStatus } from '@modules/account';

import RenderMembersAndGuests from './components/RenderMembersAndGuests';
import ButtonsComponent from './components/ButtonsComponent';
import CoursesComponent from './components/CoursesComponent';
import DatesComponent from './components/DatesComponent';
import {
  BottomInfoBox,
  InfoBlock,
  InfoBlockRow,
  InfoBlockText,
  InfoBlockTitle,
  Status,
  TicketBox,
  Title,
  TicketHistoryOnly,
} from './styled';
import SeeMoreComponent from './components/ButtonsComponent/components';

interface TicketProps {
  page?: string;
  ticket: ITicket;
  onEdit?: () => void;
  onCancel?: () => void;
  onConfirm?: () => void;
  onReject?: () => void;
  owner?: boolean;
}

const Ticket: FC<TicketProps> = ({
  page = '',
  ticket,
  onEdit,
  onCancel,
  onConfirm,
  onReject,
  owner = false,
}) => {
  const status = ticket.offerStatus === CounterStatus.REJECTED ? CounterStatus.REJECTED : ticket.status;
  const statusInfo = TicketStatusInfo[status];
  const isApproved = ticket.status === TicketStatus.APPROVED;

  return (
    <TicketBox>
      <div>
        <Title>Request</Title>

        <InfoBlockRow>
          <InfoBlock>
            <InfoBlockTitle>Date and Time</InfoBlockTitle>
            <DatesComponent showInterval={!isApproved} ticket={ticket} />
          </InfoBlock>

          <InfoBlock>
            <InfoBlockTitle>Courses</InfoBlockTitle>
            <CoursesComponent page={page} ticket={ticket} />
          </InfoBlock>
        </InfoBlockRow>

        <InfoBlockRow>
          <InfoBlock>
            <InfoBlockTitle>Members</InfoBlockTitle>
            <RenderMembersAndGuests ticket={ticket} />
          </InfoBlock>

          {ticket.comment && (
            <InfoBlock>
              <InfoBlockTitle>Comment</InfoBlockTitle>
              <InfoBlockText>{ticket.comment}</InfoBlockText>
            </InfoBlock>
          )}
        </InfoBlockRow>
      </div>
      {!isApproved ? (
        <ButtonsComponent
          owner={owner}
          page={page}
          ticket={ticket}
          onEdit={onEdit}
          onCancel={onCancel}
          onConfirm={onConfirm}
          onReject={onReject}
        />
      ) : null}
      {(isApproved || page === 'ticketHistory') ? (
        <TicketHistoryOnly>
          <SeeMoreComponent page={page} ticket={ticket} />
          <BottomInfoBox>
            <Status color={statusInfo.color}>{statusInfo.text}</Status>
          </BottomInfoBox>
        </TicketHistoryOnly>
      ) : null}
    </TicketBox>
  );
};

export default memo(Ticket);
